<div class="date-input">
	<ng-content></ng-content>
	<div *ngIf="theme !== 'analytics'" class="input-wrapper">
		<input #dateInput (click)="open()" [(ngModel)]="dateString" name="dateSelection" type="text" (keyup.enter)="updateDateFromInput()" autoComplete="off">
		<div class="date-icon">
			<i class="fal fa-calendar"></i>
		</div>
	</div>

	<bb-floating-label *ngIf="theme === 'analytics'" [label]="label" [active]="active">		
		<input #dateInput (click)="open()" [(ngModel)]="dateString" name="dateSelection" type="text" (keyup.enter)="updateDateFromInput()" autoComplete="off">
	</bb-floating-label>
</div>
<div
	class="content"
	(clickOutside)="isOpen = false"
	[hidden]="!isOpen"
	[class.analytics]="theme === 'analytics'"
	[style.bottom]="closeToBottom ? '40px' : null"
>
	<mat-calendar
		#matCalendar
		[dateClass]="dateClass()"
		(selectedChange)="onSelect($event)" 
		[minDate]="minDate"
		[maxDate]="maxDate">
	</mat-calendar>
</div>
